import OlympicsShelf from './OlympicsShelf'

export default OlympicsShelf
